module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "title-part"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429910613_toc01#toctitle2",
      "id": "title2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BOOK I THE REALM OF FIRE")])])])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("No, Time, thou shalt not boast that I do change: "), _c('br'), _vm._v("Thy pyramids built up with newer might "), _c('br'), _vm._v("To me are nothing novel, nothing strange; "), _c('br'), _vm._v("They are but dressings of a former sight.")])])]), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-873157ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429910613_p01.vue
// module id = 72
// module chunks = 0